export const modalActionTypes = {
  saveButtonClick: '[Modal frame] - save button clicked',
  confirmButtonClick: '[Modal frame] - confirm button clicked',
  dismissButtonClick: '[Modal frame] - dismiss button clicked',
  closeModalAction: '[Modal frame] - close modal',
};
